import Client from './Client'
import { Error } from './Error'

export default class Items extends Client {
  async fetchItems(token, payload) {
    try {
      // @TODO JL FIX UPDATED AT DOESNT WORK
      const query =  {
        find: payload.search,
        updated_at: payload.range,
        offset: payload.offset,
        limit: payload.limit,
      }
      return await this.request(token, 'get', 'items', null, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchItem(token, payload) {
    try {
      return await this.request(token, 'get', `items/${payload}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async deleteItem(token, id) {
    try {
      return await this.request(token, 'delete', `items/${id}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchForm(token, payload) {
    try {
      return await this.request(token, 'get', 'items/forms', null, { type: payload })
    } catch (error) {
      throw new Error(error)
    }
  }

  async createItem(token, payload) {
    try {
      const query = {
        category_id: payload.categoryId,
        identifier: payload.identifier,
        type: payload.type
      }
      return await this.request(token, 'post', 'items', payload.body, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async importCsv(token, payload) {
    try {
      const query = {
        category_id: payload.categoryId,
        identifier: payload.identifier,
        type: payload.type
      }
      return await this.request(token, 'post', 'items/import', payload.body, query)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchReports(token, payload, id) {
    try {
      const query =  {
        find: payload.search,
        state: payload.state,
        created_at: payload.range,
        offset: payload.offset,
        limit: payload.limit
      }
      return await this.request(token, 'get', `items/${id}/report`, null, query)
    } catch (error) {
      throw new Error(error)
    }
  }
}
